import { render, staticRenderFns } from "./BaseDropZone.vue?vue&type=template&id=e93f7b8c&scoped=true&"
import script from "./BaseDropZone.vue?vue&type=script&lang=ts&"
export * from "./BaseDropZone.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDropZone.vue?vue&type=style&index=0&id=e93f7b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93f7b8c",
  null
  
)

export default component.exports